import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [jobPosition, setJobPosition] = useState([]);

  // paginação vagas efetivas
  const itemsPerPage = 3;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "aon",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#2175D9] h-24">
        <div className="flex items-center justify-between p-4 pr-[10%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li className="pr-[10%]">
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div className="ml-24 w-[50%] max-[1024px]:hidden mr-24">
          <img
            src="./assets/images/banner-04.png"
            alt="AON Landing Page"
            className="w-full"
          />
        </div>
        <div
          id="main-title"
          className="flex flex-col items-center z-10 w-[50%] pr-24 max-[1024px]:hidden"
        >
          <p className="text-white text-8xl font-graphik mr-[10%] max-[768px]:text-xl tracking-tighter">
            trabalhe
          </p>
          <p className="text-white text-8xl font-graphik ml-[10%] max-[768px]:text-xl tracking-tighter">
            conosco
          </p>
          <p className="text-white text-4xl font-graphik ml-[20%] max-[768px]:text-xl tracking-tighter">
            na
          </p>
          <img
            src="./assets/images/aon-logo-white.svg"
            alt="Logo AON"
            className="w-[30%] ml-[3%] max-[768px]:w-[80%]"
          />
        </div>
        <div className="w-full md:hidden">
          <img
            src="./assets/images/banner-04-responsive.png"
            alt="AON Landing Page"
            className="w-full"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 mt-12 px-[7vw] max-[768px]:flex-col !pt-0"
        id="parceria"
      >
        <div className="flex flex-col w-full gap-8">
          <h1 className="text-4xl font-light text-blue-500">
            parceria AON e Randstad
          </h1>

          <div className="flex w-full gap-[10%] max-[768px]:hidden">
            <img
              src="./assets/images/aon-logo.svg"
              alt="Logo AON"
              className="w-[40%] max-[768px]:w-[80%]"
            />
            <img
              src="./assets/images/logo-randstad.svg"
              alt="Logo Randstad"
              className="w-[30%] max-[768px]:w-[60%]"
            />
          </div>
        </div>

        <div className="flex flex-col md:pt-12 w-full max-[768px]:w-full">
          <p className="text-lg text-black mb-2 font-light">
            A parceria entre Aon e Randstad representa uma colaboração
            estratégica entre duas organizações líderes em seus respectivos
            setores. A Aon é uma empresa global de serviços profissionais que
            oferece uma ampla gama de soluções em gestão de riscos, consultoria
            de benefícios e serviços de capital humano. Por outro lado, a
            Randstad é líder global em recrutamento e soluções completas de
            recursos humanos, presente em mais de 39 países pelo mundo. A
            Randstad trará inovações às estratégias de aquisição de talentos da
            Aon, incorporando tecnologias avançadas, análise de dados e práticas
            modernas de recrutamento. Essas melhorias visam aprimorar a
            eficiência e eficácia dos processos de contratação da Aon,
            promovendo uma gestão mais ágil e adaptável às mudanças do mercado
            de trabalho.
          </p>
          <img
            src="./assets/images/aon-logo.svg"
            alt="Logo AON"
            className="w-full p-12 md:hidden"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 pl-[7vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col md:pt-4 w-1/2 max-[768px]:w-full max-[768px]:pr-8">
          <h1 className="text-4xl font-regular text-blue-500 mb-8">
            sobre a AON
          </h1>
          <p className="text-base text-black mb-2 font-light">
            Presentes em mais de 30 cidades ao redor do mundo com Equipe local
            especializada e dedicada em transações e mais de 350 especialistas
            no mundo inteiro. Sendo uma equipe global composta por diversos
            profissionais focados em contribuir no aumento dos retornos dos
            investimentos de clientes por meio da gestão e mitigação dos riscos
            associados a cada Deal. A maximização do valor do negócio é
            alcançada pela compreensão abrangente dos riscos em cada projeto.
            Com especialização em diversos setores e ramos de riscos e seguros,
            nossa equipe dedicada exclusivamente a M&A, Private Equity e
            transações oferece uma combinação única de conhecimentos, resultando
            em soluções personalizadas para cada projeto.
          </p>

          <p className="text-base text-black mb-2 font-light mt-2">
            A Aon atende a diferentes setores com soluções personalizadas:
          </p>
          <p className="text-base text-black mb-2 mt-2 font-light">
            • Private Equity (Investidores Financeiros): oferece soluções
            personalizadas e atendimento especializado para o mercado de Private
            Equity, sendo líder global em consultoria e gestão de riscos para
            Fusões e Aquisições. • Advogados e Consultores: A equipe da Aon M&A
            and Transaction Solutions, composta por ex-profissionais de fusões e
            aquisições, compreende o processo e oferece soluções completas para
            cada transação, fortalecendo a posição de advogados e consultores.
          </p>

          <p className="text-base text-black mb-2 font-light">
            • Corporações (Investidores Estratégicos): fornece suporte
            personalizado a corporações, auxiliando em expansões e
            reestruturações com soluções exclusivas, incluindo aconselhamento em
            seguros para transações e proteção do balanço.
          </p>
          <p className="text-base text-black mb-2 font-light">
            • Advogados e Consultores: A equipe da Aon M&A and Transaction
            Solutions, composta por ex-profissionais de fusões e aquisições,
            compreende o processo e oferece soluções completas para cada
            transação, fortalecendo a posição de advogados e consultores.
          </p>

          <a href="#oportunidades" className="w-[350px] pt-4">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              clique aqui e confira nossas vagas
            </button>
          </a>
        </div>
        <div className="w-1/3 h-auto pt-24 max-[768px]:hidden">
          <img
            src="./assets/images/banner-03.png"
            alt="AON"
            className="w-full"
          />
        </div>
      </div>

      <div className="w-full h-auto py-4 max-[768px]:hidden">
        <img src="./assets/images/banner-02.png" alt="AON" className="w-full" />
      </div>

      <div className="w-full h-auto items-center justify-center flex-col flex p-8 py-4 md:hidden bg-[#2074D9]">
        <h1 className="text-4xl text-white">propósito AON</h1>
        <p className="text-lg text-white font-light pt-3 text-center">
          A Aon existe para dar melhor forma às decisões. Para proteger e
          enriquecer a vida das pessoas ao redor do mundo.
        </p>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-graphik text-blue-500 mb-4 max-[768px]:text-2xl">
          quer uma oportunidade? Então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 font-light">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <div>
          <p className="text-black text-2xl mb-8 ">
            Buscando dicas para a sua carreira? Confira nosso blog
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition max-[768px]:hidden"
            rel="noreferrer"
          >
            acesse nosso blog
          </a>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            rel="noreferrer"
            className="md:hidden"
          >
            <button className="text-blue-500 border-1 border-[#2074D9] w-full h-[60px] hover:text-white rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              acesse nosso blog
            </button>
          </a>
        </div>
      </div>

      <footer className="bg-[#2074D9] text-white pt-4">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="md:text-left mb-4 md:mb-0">
            <p>
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p className="mb-4">
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso Aviso de Privacidade.
            </p>
          </div>

          <div className="flex space-x-4 pb-8">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
